import {
  QueryBuilderAstNodeType,
  QueryBuilderOperatorType,
} from '../../../../../../../../../types';

export const foldGroup = (
  operator: QueryBuilderOperatorType,
  children: QueryBuilderAstNodeType[]
): QueryBuilderAstNodeType | null => {
  if (children.length === 0) return null;

  if (children.length === 1) return children[0];

  return {
    type: 'group',
    operator,
    children,
  };
};
